/*
 * @Author: EdwardYoung
 * @Date: 2017-07-09 00:59:06
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-02 11:58:06
 */
/**
 * 测试配置请求头使用
 */
import axios from 'axios'
import {axiosInit} from './axiosInit'

const initedAxios = axiosInit(axios)

export default initedAxios



// WEBPACK FOOTER //
// ./src/api/axios.js